export class BadGatewayError extends Error {
  code = 502;

  constructor() {
    super();
  }
}
